<template>
    <div id="newsPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto">
                    <div class="header">
                        <h3 class="m-auto">{{ $t('profile.news_title') }}</h3>
                        <a @click.prevent="open = false; btnSfx();" href="#" class="close"></a>
                    </div>
                    <div class="newsListHolder">
                        <div v-for="n in newsList" :key="n.id" @click="expandId = (expandId == n.id ? null : n.id); btnSfx();" :class="'newsItem'+(expandId == n.id ? ' active' : '')">
                            <small class="text-primary">{{ moment(n.lastModifiedDate).fromNow() }}</small>
                            <h4 v-html="n.title"></h4>
                            <div v-html="n.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../api'

const NewsPopup = Vue.component('news-popup', {
    components: {
        
    },
    data() {
        return {
            open: false,
            newsList: [],
            expandId: null,
        }
    },
    methods:{
        
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(id) {
            this.open = true;
            if(id != undefined) this.expandId = id;
            this.getList();
        },
        
        hide() {
            this.open = false;
            this.newsList = [];
            this.expandId = null;
        }, 

        setNewsList(data){
            for(let n in data){
                data[n].title = this.replaceTags(data[n].title);
                data[n].content = this.replaceTags(data[n].content);
            }

            this.newsList = data;
        },

        replaceTags(str){
            str = str.replace(/<link="(.*?)"  >(.*?)<\/link>/g, "<a target=\"_blank\" href=\"$1\">$2<\/a>");
            str = str.replace(/<color="(.*?)">(.*?)<\/color>/g, "<span style=\"color:$1;\">$2<\/color>");
            str = str.replace(/\\u2022/g, "&#x2022 ");
            str = str.replace(/(?:\r\n|\r|\n)/g, '<br>');
            return str;
        },

        getList(){
            const $this = this;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.news()
            .then((response) => {
                $this.setNewsList(response.data);
                if($this.expandId == null && $this.newsList.length > 0) 
                    $this.expandId = $this.newsList[0].id;
            })
            .catch((error) => {
                api.baseErrorHendler(error);
            })
            .then(() => {
                loader.classList.remove("show");
            });
        },
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },

    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
    
})

export default NewsPopup
</script>